import RadioGroup from "../inputs/RadioGroup";
import { RadioGroupFieldsetProps } from "./FieldsetProps";
import { RadioButtonField } from "../inputs/InputProps";

import "./Fieldset.scss";

const SB2RCMFee: React.FC<RadioGroupFieldsetProps> = ({ currentSelection, setCurrentSelection }) => {
    const fields: RadioButtonField[] = [
        {
            id: "0",
            label: (
                <>
                    Yes, exemption declared for documentary transfer tax (
                    <abbr title="Documentary Transfer Tax">DTT</abbr>) paid - "Imposition" of{" "}
                    <abbr title="Documentary Transfer Tax">DTT</abbr> refers to the actual collection of the fee and not
                    on those exempt.
                </>
            ),
        },
        {
            id: "1",
            label: 'Yes, exemption declared for documents recorded "in connection with" a transfer of real property refers to documents submitted concurrently (cap $225.00).',
        },
        {
            id: "2",
            label: "Yes, exemption that is a residential dwelling to an owner-occupier.",
        },
        {
            id: "3",
            label: "Yes, not related to real property.",
        },
        {
            id: "4",
            label: "No, this document does not meet any of the exemptions as described.",
        },
    ];

    return (
        <fieldset className="fee-calc-fieldset">
            <legend>
                <i className="fa fa-asterisk" aria-hidden="true" title="Required"></i>
                <span className="sr-only">Required</span>
                All documents recorded are subject to the Building Homes and Jobs Act fee (
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=27388.1.&lawCode=GOV"
                >
                    <abbr title="Government Code">GC</abbr>27388.1
                </a>
                ) and the Restrictive Covenant Modification fee (
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?lawCode=GOV&sectionNum=27388.2."
                >
                    <abbr title="Government Code">GC</abbr>27388.2
                </a>
                ) unless a valid exemption shown below is stated on the document. Does your document include a valid
                exemption?
            </legend>
            <RadioGroup
                currentSelection={currentSelection}
                setCurrentSelection={setCurrentSelection}
                fieldsetId="SB2_RCMFee"
                fields={fields}
            />
        </fieldset>
    );
};

export default SB2RCMFee;
